import React from 'react'
import { featureFlags } from '../config/featureFlags'
import FastenConnectCard from '../features/fasten/components/FastenConnectCard'
import HomeContentGrid from '../features/home/components/HomeContentGrid'
import HomeFaq from '../features/home/components/HomeFaq'
import HomeFooter from '../features/home/components/HomeFooter'
import HomeHero from '../features/home/components/HomeHero'
import OutstandingSecondaryConsentsCard from '../features/home/components/OutstandingSecondaryConsentsCard'
import SupportCard from '../features/home/components/SupportCard'
import TestingProgressCard from '../features/home/components/TestingProgressCard'
import { useHomeGreetingName } from '../features/home/hooks/useHomeGreetingName'
import { useOutstandingSecondaryConsents } from '../features/home/hooks/useOutstandingSecondaryConsents'

const Home: React.FC = () => {
  const firstName = useHomeGreetingName(true)
  const outstandingSecondaryConsents = useOutstandingSecondaryConsents(true)

  return (
    <div className="space-y-6 pb-2">
      <HomeHero firstName={firstName} />
      <TestingProgressCard />
      {featureFlags.enableFastenConnect ? <FastenConnectCard /> : null}
      <HomeContentGrid
        secondaryConsentCard={
          outstandingSecondaryConsents.items.length > 0 ? (
            <OutstandingSecondaryConsentsCard items={outstandingSecondaryConsents.items} />
          ) : undefined
        }
        faq={<HomeFaq />}
        support={<SupportCard />}
      />
      <HomeFooter />
    </div>
  )
}

export default Home
